import Config from "@/config/Config"
import BaseContainer from "@base/container/BaseContainer"
import Facade from "@/Facade";
import ReelsConfig from "@/config/ReelsConfig";
import SymbolsFactory from "@/factories/SymbolsFactory";
import * as PIXI from "pixi.js";
import DataField from "../model/DataField";

export default class SymbolsContainer extends BaseContainer {

    constructor(dataField) {
        super()
        this.dataField = dataField
        this.addChild(this.dataField.container)

        this.init()
    }



    init(){
        // this.dataField.allSymbols.forEach(column =>
        //      column.forEach(symbol =>  this.addChild(symbol))
        // )

    }

    update(){
        const initData = Facade.model.reelsData
        const multipliers = Facade.model.multipliers

        this.dataField.initSymbols(initData, multipliers)
    }
}
